(function() {
  var MOQ = 24;
  var pendingCartUpdates = 0;

  function getViolations(cart) {
    if (!cart.items || cart.items.length === 0) return [];
    var products = {};
    cart.items.forEach(function(item) {
      var pid = item.product_id;
      if (!products[pid]) products[pid] = { title: item.product_title, qty: 0 };
      products[pid].qty += item.quantity;
    });
    var v = [];
    for (var pid in products) {
      if (products[pid].qty < MOQ) v.push(products[pid].title + ': ' + products[pid].qty + '/' + MOQ);
    }
    return v;
  }

  function updateWarning(violations) {
    document.querySelectorAll('.moq-warning').forEach(function(el) { el.remove(); });
    var ctasArea = document.querySelector('.cart__ctas');
    if (violations.length > 0 && ctasArea) {
      var warn = document.createElement('div');
      warn.className = 'moq-warning';
      warn.innerHTML = '<strong>\u26a0 Minimum Order: ' + MOQ + ' units per style</strong>' +
        '<p>Colors can be mixed within the same style.</p>' +
        '<ul>' + violations.map(function(v) { return '<li>' + v + '</li>'; }).join('') + '</ul>';
      ctasArea.parentNode.insertBefore(warn, ctasArea);
    }
  }

  function softCheck() {
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      var v = getViolations(cart);
      if (window.location.pathname === '/cart') updateWarning(v);
      var btn = document.querySelector('.cart__checkout-button');
      var dyn = document.querySelector('.cart__dynamic-checkout-buttons');
      if (v.length > 0) {
        if (btn) btn.style.opacity = '0.4';
        if (dyn) dyn.style.opacity = '0.4';
      } else {
        if (btn) btn.style.opacity = '';
        if (dyn) dyn.style.opacity = '';
      }
    });
  }

  if (window.location.pathname === '/cart') softCheck();

  /* Track in-flight cart mutations */
  function isCartMutation(url) {
    return typeof url === 'string' &&
      (url.indexOf('/cart/change') > -1 || url.indexOf('/cart/update') > -1 || url.indexOf('/cart/add') > -1);
  }

  var origFetch = window.fetch;
  window.fetch = function() {
    var url = arguments[0];
    if (isCartMutation(url)) {
      pendingCartUpdates++;
      return origFetch.apply(this, arguments).then(function(response) {
        pendingCartUpdates--;
        setTimeout(softCheck, 300);
        return response;
      }).catch(function(err) {
        pendingCartUpdates--;
        throw err;
      });
    }
    return origFetch.apply(this, arguments);
  };

  var origXHR = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    if (isCartMutation(url)) {
      pendingCartUpdates++;
      this.addEventListener('loadend', function() {
        pendingCartUpdates--;
        setTimeout(softCheck, 300);
      });
    }
    return origXHR.apply(this, arguments);
  };

  document.addEventListener('change', function(e) {
    if (e.target.name === 'updates[]' || e.target.classList.contains('quantity__input')) setTimeout(softCheck, 300);
  });

  /* Wait for pending cart updates to finish, then validate */
  function waitAndValidate(callback) {
    if (pendingCartUpdates > 0) {
      setTimeout(function() { waitAndValidate(callback); }, 100);
    } else {
      /* Extra 200ms buffer after last update settles */
      setTimeout(function() {
        fetch('/cart.js').then(function(r) { return r.json(); }).then(callback);
      }, 200);
    }
  }

  /* HARD GATE: intercept all checkout buttons */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[name="checkout"]');
    if (!btn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    waitAndValidate(function(cart) {
      var v = getViolations(cart);
      if (window.location.pathname === '/cart') updateWarning(v);

      if (v.length === 0) {
        window.location.href = '/checkout';
      } else {
        alert('Minimum order not met:\n\n' + v.join('\n') + '\n\nEach style requires at least ' + MOQ + ' units.\nColors can be mixed within the same style.');
      }
    });
  }, true);

  /* Block dynamic checkout buttons */
  document.addEventListener('click', function(e) {
    var dynArea = e.target.closest('.cart__dynamic-checkout-buttons, .additional-checkout-buttons');
    if (!dynArea) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    waitAndValidate(function(cart) {
      var v = getViolations(cart);
      if (v.length > 0) {
        if (window.location.pathname === '/cart') updateWarning(v);
        alert('Minimum order not met:\n\n' + v.join('\n') + '\n\nEach style requires at least ' + MOQ + ' units.\nColors can be mixed within the same style.');
      }
    });
  }, true);

})();
